import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IUserState {
  token: string | null;
}

const initialState: IUserState = {
  token: null,
};

export const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    removeToken: (state: any) => {
      state.token = null;
      localStorage.removeItem("token");
    },
    storeToken: (state: any, action: PayloadAction<string>) => {
      console.log(action.payload);
      state.token = action.payload;
    },
  },
});

export const { removeToken, storeToken } = userDataSlice.actions;

export default userDataSlice.reducer;
